import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default {
  logoutForExpiredToken () {
    store.dispatch('setActive', true)
    localStorage.removeItem('access_token')
    localStorage.removeItem('permission')
    localStorage.removeItem('user')
    store.dispatch('setPermission', '')
    router.push('singin')
  },
  logout () {
    store.dispatch('setActive', true)
    const token = localStorage.getItem('access_token')
    localStorage.removeItem('access_token')
    localStorage.removeItem('permission')
    localStorage.removeItem('user')
    store.dispatch('setPermission', '')
    router.push('singin')
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/api/auth/logout',
        headers: {
          Authorization: 'Bearer' + token
        }
      })
        .then(response => {
          resolve(true)
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
    })
  },
  authUser () {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/api/authUser',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then(response => {
          const user = response.data
          store.dispatch('setUser', response.data)
          store.dispatch('setUserRoles', user.roles)
          store.dispatch('setUserName', user.user_name)
          store.dispatch('setUserId', user.user_id)
          resolve(user)
        })
        .catch(err => {
          console.log(err)
          if (err.response) {
            this.$snotify.error(
              err.response.data.error,
              'Error',
              this.$store.state.snotify
            )
          }
        })
    })
  }
}
